// Dependencies
import styled, { css } from "styled-components";

// Utils
import { theme } from "config/theme";

type ContainerStyleProps = {
    isNotRead: boolean;
};

export const Container = styled.div<ContainerStyleProps>`
    gap: 8px;
    width: 100%;
    display: flex;
    padding: 16px;
    cursor: pointer;
    min-height: 52px;
    justify-content: center;
    box-sizing: border-box;
    border-bottom: 1px solid ${theme.colors.base[100]};

    &:last-child {
        border: none;
    }

    .photo-user {
        border-radius: 50%;
    }

    .photo-tag {
        width: 48px;
        height: 48px;
        display: flex;
        position: relative;
        margin-right: 16px;
    }

    .tag-user {
        width: 24px;
        height: 24px;
        display: flex;
        position: absolute;
        right: -2px;
        bottom: -5px;
        border-radius: 400px;
        border: 2px solid ${theme.colors.base[100]};
    }

    .description-time {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 1rem;
        font-weight: 400;
        font-weight: 400;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        letter-spacing: 0;
        line-height: 1.375;
    }

    .description-name {
        margin-bottom: 8px;
    }

    .description {
        color: ${theme.colors.base[400]};
    }

    .time-button {
        font-size: 14px;
        line-height: 16px;
        display: flex;
        justify-content: space-between;
    }

    .time {
        color: ${theme.colors.base[400]};
    }

    .button-action {
        border: none;
        display: flex;
        background-color: transparent;
        color: ${theme.colors.system.info[300]};
        cursor: pointer;
    }

    .arrow-rigth {
        margin-left: 10px;
        background: black;
    }

    @media (min-width: 768px) {
        .photo-tag {
            width: 40px;
            height: 40px;
        }

        .tag-user {
            width: 20px;
            height: 20px;
        }
    }

    @media (min-width: 1920px) {
        padding: 24px;
    }

    ${({ isNotRead }) =>
        !!isNotRead &&
        css`
            background-color: ${theme.colors.system.info[100]};

            .dot {
                min-width: 12px;
                height: 12px;
                background: ${theme.colors.system.danger[300]};
                border: 2px solid ${theme.colors.white};
                margin: auto 8px auto 0;
                border-radius: 50%;
            }
        `}
`;
